(function () {
    var typed = '';
    var TRIGGER = 'gregor';
    var bugTimer = null;
    var stopBtn = null;

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > TRIGGER.length) typed = typed.slice(-TRIGGER.length);
        if (typed === TRIGGER) { typed = ''; startBugs(); }
    });

    if (decodeURIComponent(window.location.pathname).includes('/bücher/die-verwandlung')) {
        setTimeout(startBugs, 700);
    }

    function startBugs() {
        if (bugTimer) return;

        stopBtn = document.createElement('button');
        stopBtn.className = 'ee-close';
        stopBtn.style.cssText = 'position:fixed;top:1rem;right:1.2rem;z-index:10001;';
        stopBtn.textContent = '×';
        stopBtn.addEventListener('click', stopBugs);
        document.body.appendChild(stopBtn);

        spawnBeetle();
        schedule();
    }

    function schedule() {
        bugTimer = setTimeout(function () {
            if (!bugTimer) return;
            spawnBeetle();
            schedule();
        }, 1100 + Math.random() * 900);
    }

    function stopBugs() {
        clearTimeout(bugTimer);
        bugTimer = null;
        document.querySelectorAll('.verwandlung-outer').forEach(function (el) { el.remove(); });
        if (stopBtn) { stopBtn.remove(); stopBtn = null; }
    }

    function spawnBeetle() {
        var outer = document.createElement('div');
        outer.className = 'verwandlung-outer';
        outer.style.cssText = 'position:fixed;top:' + (6 + Math.random() * 80) + '%;left:0;z-index:9998;pointer-events:none;';

        var goLeft = Math.random() > 0.5;
        var speed = 6 + Math.random() * 9;
        var w = Math.round(44 + Math.random() * 44);
        var h = Math.round(w * 50 / 90);

        var carrier = document.createElement('div');
        carrier.className = 'verwandlung-carrier--' + (goLeft ? 'rtl' : 'ltr');
        carrier.style.animationDuration = speed + 's';

        var bugEl = document.createElement('div');
        if (goLeft) bugEl.style.transform = 'scaleX(-1)';
        bugEl.innerHTML = makeBug(w, h);

        carrier.appendChild(bugEl);
        outer.appendChild(carrier);
        document.body.appendChild(outer);

        setTimeout(function () { if (outer.parentNode) outer.remove(); }, (speed + 0.5) * 1000);
    }

    function makeBug(w, h) {
        var b = '#4a2810'; var h2 = '#5c3415'; var l = '#3a200a';
        return '<svg viewBox="0 0 90 50" width="' + w + '" height="' + h + '" xmlns="http://www.w3.org/2000/svg"'
            + ' style="filter:drop-shadow(0 0 2px rgba(90,50,15,0.5))">'
            // Body
            + '<ellipse cx="36" cy="25" rx="26" ry="13" fill="' + b + '"/>'
            // Pronotum
            + '<ellipse cx="52" cy="25" rx="9" ry="11" fill="' + h2 + '"/>'
            // Head
            + '<ellipse cx="64" cy="25" rx="11" ry="9" fill="' + h2 + '"/>'
            // Wing seam
            + '<line x1="12" y1="25" x2="55" y2="25" stroke="rgba(0,0,0,0.45)" stroke-width="0.9"/>'
            // Antennae
            + '<path d="M70,21 Q79,14 87,9" fill="none" stroke="' + l + '" stroke-width="1.3" stroke-linecap="round"/>'
            + '<path d="M70,29 Q79,36 87,41" fill="none" stroke="' + l + '" stroke-width="1.3" stroke-linecap="round"/>'
            // Front legs
            + '<path d="M50,19 L45,11 L40,7" fill="none" stroke="' + l + '" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
            + '<path d="M50,31 L45,39 L40,43" fill="none" stroke="' + l + '" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
            // Middle legs
            + '<path d="M37,19 L28,10 L22,7" fill="none" stroke="' + l + '" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
            + '<path d="M37,31 L28,40 L22,43" fill="none" stroke="' + l + '" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
            // Back legs
            + '<path d="M22,20 L13,13 L7,9" fill="none" stroke="' + l + '" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
            + '<path d="M22,30 L13,37 L7,41" fill="none" stroke="' + l + '" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
            + '</svg>';
    }
})();
